// tslint:disable: no-inferrable-types
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

import {
  WorkflowInitialTransitionForm,
  WorkflowInitialTransitionFormOptions,
} from './initial-transition-form.model';

@Component({
    selector: 'eas-workflow-initial-transition-form',
    templateUrl: './initial-transition-form.component.html',
    styleUrls: ['./initial-transition-form.component.css'],
    standalone: false
})
export class WorkflowInitialTransitionFormComponent {
  public readonly model: WorkflowInitialTransitionForm;

  public constructor(formBuilder: FormBuilder,
                     @Inject(MAT_DIALOG_DATA) data: WorkflowInitialTransitionFormOptions,
                     private dialogRef: MatDialogRef<WorkflowInitialTransitionFormComponent>) {
    this.model = new WorkflowInitialTransitionForm(formBuilder,
                                                   data.transition,
                                                   data.states,
                                                   data.roles);
  }

  // Compare function for mat-select to handle objects
  public compareOptionsByID(o1: any, o2: any) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

  //
  // Actions
  //

  public onSave(): void {
    this.dialogRef.close(this.model.value);
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  //
  // Template helpers
  //

  public shouldShowError(controlOrErrorCode: string): boolean {
    return this.model.dirty &&
           (this.model.invalid(controlOrErrorCode) ||
            this.model.hasError(controlOrErrorCode));
  }
}
